import * as React from "react";

import { DashboardProvider } from "./_infra/dashboardProvider";
import { ClientDashboard } from "./clientDashboard";

export const ClientDashboardContainer = () => (
    <DashboardProvider>
        <ClientDashboard />
    </DashboardProvider>
);
